import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { i18n } from "../../translate/i18n";
import { getTokens } from "../../styles/tokens";
import {
  usePanelStyles,
  ModalTitle,
  FormField,
  FormGrid,
  FormSection,
} from "../QueueIntegrationModal/panelKit";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    radios: { display: "flex", flexWrap: "wrap", columnGap: 20, rowGap: 0 },
    optionList: { display: "flex", flexDirection: "column", gap: 8 },
    option: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      minWidth: 0,
      padding: "8px 10px",
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.sm,
      backgroundColor: t.muted,
    },
    optionNumber: {
      flex: "none",
      minWidth: 26,
      height: 26,
      padding: "0 6px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: t.radius.badge,
      backgroundColor: t.tint.soft,
      color: t.brand,
      fontSize: 12.5,
      fontWeight: 600,
      fontVariantNumeric: "tabular-nums",
    },
    optionRemove: { flex: "none", padding: 7, color: t.textSecondary },
    emptyOptions: {
      padding: "14px 12px",
      border: `1px dashed ${t.lineStrong}`,
      borderRadius: t.radius.sm,
      backgroundColor: t.muted,
      fontSize: 12.5,
      color: t.textSecondary,
      textAlign: "center",
    },
  };
});

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite um nome!"),
  text: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite uma mensagem!"),
});

const LEMBRETE_PADRAO =
  "Oi, ainda está por aí? 😊 Eu preciso que você escolha alguma das opções do menu para poder dar continuidade com esta conversa. As datas mais procuradas da temporada costumam esgotar rápido, então escolha uma opção agora e eu já confiro a disponibilidade e o melhor valor para você garantir a sua estadia! 🏖️";

// rótulo dos nós no seletor do atalho de datas
const NODE_TYPE_LABEL = {
  message: "Texto",
  menu: "Menu",
  interval: "Intervalo",
  img: "Imagem",
  audio: "Áudio",
  video: "Vídeo",
  randomizer: "Randomizador",
  singleBlock: "Conteúdo",
  ticket: "Fila",
  erp: "Integração / agente",
  readMedia: "Ler arquivo (IA)",
  tag: "Tag",
  removeTag: "Remover tag",
  switchFlow: "Trocar fluxo",
  attendant: "Atendente",
  httpRequest: "Requisição HTTP",
  variable: "Variável",
  openai: "OpenAI",
  gemini: "Gemini",
  input: "Pergunta",
};

const nodeOptionLabel = (node) => {
  const d = (node && node.data) || {};
  const tipo = NODE_TYPE_LABEL[node.type] || node.type;
  const raw =
    d.integrationName ||
    (d.queue && d.queue.name) ||
    (d.user && d.user.name) ||
    d.label ||
    d.message ||
    d.text ||
    d.name ||
    d.title ||
    "";
  const titulo = String(raw).replace(/\s+/g, " ").trim();
  const curto = titulo.length > 50 ? `${titulo.slice(0, 50)}…` : titulo;
  return curto ? `${tipo} — ${curto}` : `${tipo} (${String(node.id).slice(0, 6)})`;
};

const FlowBuilderMenuModal = ({ open, onSave, onUpdate, data, close, nodes = [] }) => {
  const classes = useStyles();
  const panel = usePanelStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [textDig, setTextDig] = useState();

  const [arrayOption, setArrayOption] = useState([]);

  const [valueRadioButton, setValueRadionButton] = useState("number");

  // lembrete se o cliente não escolher nenhuma opção (0 = desligado)
  const [lembreteSegundos, setLembreteSegundos] = useState(0);

  const [lembreteMensagem, setLembreteMensagem] = useState("");

  // atalho: se o cliente mandar datas, o fluxo pula o menu e segue para este nó ("" = não usar)
  const [atalhoDatasNodeId, setAtalhoDatasNodeId] = useState("");

  // texto livre: cliente escreve em vez de escolher uma opção → segue para este nó ("" = "Opção inválida")
  const [textoLivreNodeId, setTextoLivreNodeId] = useState("");

  const [labels, setLabels] = useState({
    title: "Adicionar menu ao fluxo",
    btn: "Adicionar",
  });

  useEffect(() => {
    console.log(data);
    if (open === "edit") {
      setLabels({
        title: "Editar menu",
        btn: "Salvar",
      });
      setTextDig(data.data.message);
      setArrayOption(data.data.arrayOption);
      setValueRadionButton(data.data.typeMenu);
      setLembreteSegundos(Number(data.data.lembreteSegundos) || 0);
      setLembreteMensagem(data.data.lembreteMensagem || "");
      setAtalhoDatasNodeId(data.data.atalhoDatasNodeId || "");
      setTextoLivreNodeId(data.data.textoLivreNodeId || "");

      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: "Adicionar menu ao fluxo",
        btn: "Adicionar",
      });
      setTextDig();
      setArrayOption([]);
      setValueRadionButton();
      setLembreteSegundos(60);
      setLembreteMensagem(LEMBRETE_PADRAO);
      setAtalhoDatasNodeId("");
      setTextoLivreNodeId("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: {
          message: textDig,
          arrayOption: arrayOption,
          typeMenu: valueRadioButton,
          lembreteSegundos: Number(lembreteSegundos) || 0,
          lembreteMensagem: lembreteMensagem,
          atalhoDatasNodeId: atalhoDatasNodeId || "",
          textoLivreNodeId: textoLivreNodeId || "",
        },
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({
        message: textDig,
        arrayOption: arrayOption,
        typeMenu: valueRadioButton,
        lembreteSegundos: Number(lembreteSegundos) || 0,
        lembreteMensagem: lembreteMensagem,
        atalhoDatasNodeId: atalhoDatasNodeId || "",
        textoLivreNodeId: textoLivreNodeId || "",
      });
    }
  };

  const ownId = open === "edit" && data ? data.id : null;
  const atalhoOptions = (nodes || []).filter(
    (n) => n && n.id !== ownId && n.type !== "start"
  );
  // nó apagado depois de configurado: mantém o valor visível para o usuário trocar
  const atalhoOrfao =
    atalhoDatasNodeId && !atalhoOptions.some((n) => n.id === atalhoDatasNodeId);
  const textoLivreOrfao =
    textoLivreNodeId && !atalhoOptions.some((n) => n.id === textoLivreNodeId);

  const removeOption = (number) => {
    setArrayOption((old) => old.filter((item) => item.number !== number));
  };

  const handleChangeRadionButton = (event) => {
    setValueRadionButton(event.target.value);
    console.log(event.target.value);
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={labels.title}
        subtitle="Envia um menu de opções e segue pelo caminho da opção escolhida."
        onClose={handleClose}
      />
      <DialogContent>
        <FormSection title="Mensagem">
          <div className={panel.stack}>
            <FormField label="Formato do menu">
              <RadioGroup
                defaultValue="numero"
                value={valueRadioButton}
                onChange={handleChangeRadionButton}
                className={classes.radios}
                row
              >
                <FormControlLabel
                  value="number"
                  control={<Radio color="primary" size="small" />}
                  label="Número"
                />
                <FormControlLabel
                  value="list"
                  control={<Radio color="primary" size="small" />}
                  label="Lista"
                />
                <FormControlLabel
                  value="button"
                  control={<Radio color="primary" size="small" />}
                  label="Botão"
                />
              </RadioGroup>
            </FormField>
            <FormField label="Mensagem de explicação do menu">
              <TextField
                minRows={4}
                name="text"
                multiline
                variant="outlined"
                size="small"
                fullWidth
                value={textDig}
                onChange={(e) => setTextDig(e.target.value)}
              />
            </FormField>
          </div>
        </FormSection>

        <FormSection
          title="Opções"
          description="Cada opção vira uma saída do nó no fluxo."
        >
          <div className={classes.optionList}>
            {arrayOption.length === 0 && (
              <div className={classes.emptyOptions}>
                Nenhuma opção ainda. Adicione a primeira.
              </div>
            )}
            {arrayOption.map((item, index) => (
              <div className={classes.option} key={item.number}>
                <Tooltip title={`Digite ${item.number}`}>
                  <span className={classes.optionNumber}>{item.number}</span>
                </Tooltip>
                <TextField
                  placeholder={"Digite opção"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  defaultValue={item.value}
                  inputProps={{ "aria-label": `Opção ${item.number}` }}
                  onChange={(event) =>
                    setArrayOption((old) => {
                      let newArr = old;
                      newArr[index].value = event.target.value;
                      return newArr;
                    })
                  }
                />
                {arrayOption.length === item.number && (
                  <Tooltip title="Remover opção">
                    <IconButton
                      className={classes.optionRemove}
                      aria-label={`Remover opção ${item.number}`}
                      onClick={() => removeOption(item.number)}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            ))}
            <div>
              <Button
                onClick={() =>
                  setArrayOption((old) => [
                    ...old,
                    { number: old.length + 1, value: "" },
                  ])
                }
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
              >
                Adicionar opção
              </Button>
            </div>
          </div>
        </FormSection>

        <FormSection
          title="Atalho de datas"
          description="Se o cliente já mandar datas (ex.: “tem vaga de 10 a 13/11?”), o menu não é enviado e o fluxo segue direto para o nó escolhido — por exemplo, o agente que responde à pergunta."
        >
          <FormField label="Se o cliente mandar datas, ir para:">
            <TextField
              select
              variant="outlined"
              size="small"
              fullWidth
              value={atalhoDatasNodeId || ""}
              onChange={(e) => setAtalhoDatasNodeId(e.target.value)}
              SelectProps={{ displayEmpty: true }}
            >
              <MenuItem value="">— não usar —</MenuItem>
              {atalhoOrfao && (
                <MenuItem value={atalhoDatasNodeId}>
                  Nó removido ({String(atalhoDatasNodeId).slice(0, 6)})
                </MenuItem>
              )}
              {atalhoOptions.map((n) => (
                <MenuItem key={n.id} value={n.id}>
                  {nodeOptionLabel(n)}
                </MenuItem>
              ))}
            </TextField>
          </FormField>
        </FormSection>

        <FormSection
          title="Texto livre"
          description="Se o cliente escrever em vez de escolher uma opção (ex.: “estou sem internet”), a mensagem segue para o nó escolhido — por exemplo, o agente de IA, que responde ao que ele escreveu. Cumprimentos soltos (“oi”, “bom dia”) nunca viram “Opção inválida”."
        >
          <FormField label="Se o cliente escrever em vez de escolher, ir para:">
            <TextField
              select
              variant="outlined"
              size="small"
              fullWidth
              value={textoLivreNodeId || ""}
              onChange={(e) => setTextoLivreNodeId(e.target.value)}
              SelectProps={{ displayEmpty: true }}
            >
              <MenuItem value="">— responder “Opção inválida” —</MenuItem>
              {textoLivreOrfao && (
                <MenuItem value={textoLivreNodeId}>
                  Nó removido ({String(textoLivreNodeId).slice(0, 6)})
                </MenuItem>
              )}
              {atalhoOptions.map((n) => (
                <MenuItem key={n.id} value={n.id}>
                  {nodeOptionLabel(n)}
                </MenuItem>
              ))}
            </TextField>
          </FormField>
        </FormSection>

        <FormSection
          title="Lembrete"
          description="Enviado uma vez se o cliente não escolher nenhuma opção."
        >
          <FormGrid>
            <FormField
              label="Lembrete após (segundos)"
              help="0 = sem lembrete"
            >
              <TextField
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                value={lembreteSegundos}
                onChange={(e) => setLembreteSegundos(e.target.value)}
                inputProps={{ min: 0, max: 3600 }}
              />
            </FormField>
            <FormField
              full
              label="Mensagem se o cliente não escolher nenhuma opção"
            >
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={3}
                value={lembreteMensagem}
                placeholder={LEMBRETE_PADRAO}
                onChange={(e) => setLembreteMensagem(e.target.value)}
              />
            </FormField>
          </FormGrid>
        </FormSection>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => handleSaveContact()}
        >
          {`${labels.btn}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderMenuModal;
